import { render, staticRenderFns } from "./Foyer.vue?vue&type=template&id=3ca70520"
import script from "./Foyer.vue?vue&type=script&lang=js"
export * from "./Foyer.vue?vue&type=script&lang=js"
import style0 from "./Foyer.vue?vue&type=style&index=0&id=3ca70520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports